"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.returnTimeTillEvents = exports.getCurrentDate = void 0;
exports.getDebugDate = getDebugDate;
const date_fns_1 = require("date-fns");
/**
 * @returns the current datetime, will use debug mode saved in localstorage.
 * @deprecated Use new EventrDate(). PLEASE!
 */
const getCurrentDate = () => {
    if (typeof window === 'undefined')
        return new Date();
    const dTime = localStorage.getItem('debugTime');
    if (dTime === null) {
        return new Date();
    }
    else {
        return new Date(dTime);
    }
};
exports.getCurrentDate = getCurrentDate;
function getDebugDate() {
    if (typeof window === 'undefined')
        return undefined;
    const overrideDate = window?.localStorage?.getItem('overrideDate');
    if (overrideDate === null || overrideDate === 'null') {
        return undefined;
    }
    else {
        return overrideDate;
    }
}
const returnTimeTillEvents = (eventDate) => {
    const currentDate = new Date();
    if (eventDate < currentDate) {
        return 'Event has already passed.';
    }
    const timeDifferenceString = (0, date_fns_1.formatDistanceToNow)(eventDate, {
        addSuffix: true,
    });
    return timeDifferenceString;
};
exports.returnTimeTillEvents = returnTimeTillEvents;
